import { datadogRum } from '@datadog/browser-rum';

const RUM_CONFIG_DEFAULTS = {
  site: 'datadoghq.com',
  proxy: 'https://dd.marketspark.com',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input' as const,
};

export const initDatadogRum = ({
  applicationId,
  clientToken,
  service,
  enabled,
  env,
  version,
}: {
  applicationId: string;
  clientToken: string;
  service: string;
  enabled: boolean;
  env: string;
  version: string;
}) => {
  if (!enabled) {
    return;
  }
  datadogRum.init({
    ...RUM_CONFIG_DEFAULTS,
    applicationId,
    clientToken,
    service,
    env,
    version,
  });
};

export const setDatadogRumUser = (user: { id: string; name?: string; email?: string }) => {
  datadogRum.setUser(user);
};

export const clearDatadogRumUser = () => {
  datadogRum.clearUser();
};

export const setDatadogRumGlobalContextProperty = (key: string, value: unknown) => {
  datadogRum.setGlobalContextProperty(key, value);
};
